import React, {useEffect, useState} from 'react';
import AwardMedal from '../../../../components-new/general/AwardMedal';
import {getMyAwards} from '../../../../services/statistics/api';

/*
 * The signed-in operator's own medal, in the header.
 *
 * Only the fetching: the drawing is AwardMedal, which the profile drawer uses
 * too. The two places know different things - here it is "mine", there it is
 * "theirs" - and that is the whole of the difference between them.
 */
const MyAwardMedal = () => {
    const [awards, setAwards] = useState([]);

    useEffect(() => {
        let active = true;

        getMyAwards()
            .then(months => {
                if (active) setAwards(months || []);
            })
            .catch(() => {
                /* a medal is the one thing in the header that can be missing
                   without the page being wrong */
            });

        return () => {
            active = false;
        };
    }, []);

    return <AwardMedal awards={awards}/>;
};

export default MyAwardMedal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/MyAwardMedal.jsx